import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    ViewContainerRef,
    ViewChild,
    ElementRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Page } from '../../../../../../../models/page';
import { PageService } from '../../../../../../../services/page.service';
import { Helpers } from '../../../../../../../helpers';
import { BaseComponent } from '../../../../base.component';
import { SiteService } from '../../../../../../../services/site.service';
import { PublisherDetailTab } from '../../../../owner/publisher-detail/publisher-detail.component';
import { DataService } from '../../../../../../../_services/data.service';
import { Paths } from '../../../../../../../models/enums';

@Component({
    selector: 'app-page',
    templateUrl: './create-page.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreatePageComponent extends BaseComponent implements OnInit {
    returnUrl: any;
    page: Page = new Page();
    siteId: string;
    publisherName: string;

    constructor(
        private pageService: PageService,
        private dataService: DataService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        super();
        this.siteId = route.snapshot.queryParams.siteId;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        if (this.siteId == null) this.router.navigate([this.returnUrl]);
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.breadcrumb = route.snapshot.queryParams.siteName;
        route.snapshot.parent.data.queryParams = { siteId: this.siteId };
        route.snapshot.parent.data.url = '/' + route.snapshot.queryParams.returnUrl;
        route.snapshot.parent.parent.data.url =
            '/' + route.snapshot.queryParams.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.queryParams.tab = PublisherDetailTab.Inventory;
            route.snapshot.parent.parent.data.breadcrumb = this.publisherName;
            route.snapshot.parent.parent.data.queryParams = {
                name: this.publisherName
            };
        }
    }

    ngOnInit() { }

    navigate(pageId = null) {
        let queryParams = {
            siteId: this.siteId
        };
        if (this.dataService.path == Paths.Owner) {
            queryParams['tab'] = PublisherDetailTab.Inventory;
            queryParams['name'] = this.publisherName;
        }
        if (pageId != null) queryParams['pageId'] = pageId;
        this.router.navigate([this.returnUrl], { queryParams: queryParams });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    createPage() {
        var _self = this;
        Helpers.setLoading(true);
        _self.page.siteId = _self.siteId;
        this.pageService.create(_self.page).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            setTimeout(function() {
                _self.navigate(res.data);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/page/create-page/create-page.component.ts